import { useCallback } from "react";
import { useDisplayDate } from "../../../common/formatting/useDisplayDate";
import { useDisplayDateWithTime } from "../../../common/formatting/useDisplayDateWithTime";
import type { PhaseDate } from "./phaseDates";

export const useTimelineDate = () => {
  const displayDate = useDisplayDate();
  const displayDateWithTime = useDisplayDateWithTime();
  return useCallback(
    ({ iso, timed }: PhaseDate) => (timed ? displayDateWithTime(iso) : displayDate(iso)),
    [displayDate, displayDateWithTime],
  );
};
